core.factory('applicationModel', ['$rootScope', 'core.baseModel', 'core.applicationService', '$injector',
	function($rootScope, baseModel, applicationService, $injector) {

	   function ApplicationModel() {

           var config = {};
           if($injector.has('meedyConfig')) {
               config = $injector.get('meedyConfig');
           } else if($injector.has('edmConstant')) {
               config = $injector.get('config');
           } else {
               config = $injector.get('coreConfig');
           }
	
	       var self = this;

		   this.applicationName = config.APPLICATION_NAME;
		   this.applicationCustomer = config.APPLICATION_CUSTOMER;
		   this.applicationVersion = config.VERSION;

		   this.customConfig = null;

		   this.devMode = config.DEV_MODE;
		   this.showPerformanceStats = false;

		   this.actionInProgress = false;

		   this.viewReady = false;
		   this.viewDirty = false;

		   this.currentState = null;
		   this.currentUrl = null;

		   this.isLoggedIn = false; // use this when not using CAS

		   this.isLoading = false;
		   this.lastApplicationError = null;

           this.titleBar = null;
           this.sideBarItems = [];
		   this.modules = [];

           this.slidePanelState = {
               collapsed: false
           };

           this.fillViewportMode = false;

		   this.setModules = function(modules) {
			   self.modules = modules;
		   };

           this.setSideBarItems = function(items) {
               self.sideBarItems = items;
           };

           this.setBreadcrumbItems = function(items) {
               self.breadcrumbItems = items;
           };
           
           this.setMenuItems = function(items) {
               self.menuItems = items;
           };

           this.selectMenuItemWithState = function(state) {
               this.deselectMenuItems();

               var menuItemToSelect = _.find(self.menuItems, { state: state });

               if (menuItemToSelect) {
                   menuItemToSelect.selected = true;
               }
           };

           this.deselectMenuItems = function() {
               _.each(self.menuItems, function(menuItem) {
                   menuItem.selected = false;
               });
           };


           this.setTitleBar = function(titleBarTitle, titleBarIconClass, titleBarSubtitle) {
               self.titleBar = {
                   title: titleBarTitle,
                   icon: titleBarIconClass,
                   subtitle: titleBarSubtitle
               };
           };

           this.deselectSideBarItems = function() {
               _.each(self.sideBarItems, function(sideBarItem) {
                   sideBarItem.selected = false;

                   _.each(sideBarItem.children, function(childSideBarItem) {
                       childSideBarItem.selected = false;
                   });
               });
           };

           this.selectSideBarItemWithState = function(state, childState) {
               self.deselectSideBarItems();

               var sideBarItemToSelect = _.find(self.sideBarItems, { state: state });

               if (sideBarItemToSelect) {
                   sideBarItemToSelect.selected = true;

                   if (childState) {
                       var childSideBarItemToSelect = _.find(sideBarItemToSelect.children, { state: childState });
                       if (childSideBarItemToSelect) {
                           childSideBarItemToSelect.selected = true;
                       }
                   }
               }
           };

		   this.getCustomConfig = function() {
			   applicationService.getCustomConfig().then(
				   function (customConfig) {
					   self.customConfig = customConfig;
					   $rootScope.$broadcast(Event.MEEDY.APPLICATION.GET_CUSTOM_CONFIG.SUCCESS, customConfig);
				   },
				   function(error) {
					   $rootScope.$broadcast(Event.MEEDY.APPLICATION.GET_CUSTOM_CONFIG.ERROR, error);
				   }
			   )
		   };

		   this.sendError = function(applicationError) {
			   self.lastApplicationError = applicationError;

			   applicationService.sendError(applicationError).then(
				   function (result) {
					   // nothing
				   },
				   function(error) {
					   // nothing
				   }
			   )
		   };
	   }
	
	   return new ApplicationModel();
	
	}
]);
